/**
 * WinCampaign SureCart Checkout Configuration
 * ------------------------------------------------------------------
 * Single source of truth for every SureCart checkout URL used across
 * the app. Update this file (and this file only) to change checkout
 * destinations, add new plans, or add new add-ons — the enrollment
 * logic reads from here dynamically.
 *
 * Source of truth (Google Sheet):
 * https://docs.google.com/spreadsheets/d/10QTkYfTqbca9_aSEDKS5kD5P1yvmpNF2Ko_vYpc9a5U/
 */

export type PlanId = "premium" | "elite";
export type BillingId = "monthly" | "annual" | "fivePay";

export interface CheckoutConfig {
  premium: Record<BillingId, string>;
  elite: Record<BillingId, string>;
  discoveryCall: string;
}

export const checkoutConfig: CheckoutConfig = {
  premium: {
    monthly:
      "https://founders.wincampaign.io/buy/dfy-business-growth-accelerator",
    annual:
      "https://founders.wincampaign.io/buy/dfy-business-growth-accelerator-premium-annual",
    fivePay:
      "https://founders.wincampaign.io/buy/dfy-business-growth-accelerator-premium-5-easy-payment-plans",
  },
  elite: {
    monthly:
      "https://founders.wincampaign.io/buy/dfy-business-growth-accelerator-elite-monthly",
    annual:
      "https://founders.wincampaign.io/buy/dfy-business-growth-accelerator-elite-annual",
    fivePay:
      "https://founders.wincampaign.io/buy/dfy-business-growth-accelerator-elite-5-easy-payment-plan",
  },
  discoveryCall:
    "https://founders.wincampaign.io/buy/wc-discovery-call-support",
};

/**
 * Resolve a plan + billing selection to a SureCart checkout URL.
 * Falls back to an empty string if the mapping is missing so callers can
 * defensively guard against a broken redirect.
 */
export function getCheckoutUrl(plan: PlanId, billing: BillingId): string {
  return checkoutConfig[plan]?.[billing] ?? "";
}

export function getDiscoveryCallUrl(): string {
  return checkoutConfig.discoveryCall;
}
